import React from 'react';
import Layout from './layout.js';
import NewsGrid from './news-grid.js';
import Footer from './footer.js';

class News extends React.Component {
  render() {
    return (
      <div>
        <Layout>
          <NewsGrid />
        </Layout>
        <Footer footerClass="news" />
      </div>
    );
  }
}

export default News;



// WEBPACK FOOTER //
// ./src/scripts/components/news.js